/*       */

// $FlowFixMe
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Grid, IconButton, ListItemText, List, ListItem, ListItemSecondaryAction, MdiIcon } from '@mic3/platform-ui';
import DraggableElement from 'app/components/molecules/Dnd/DraggableElement';
import RowTarget, { EmptyRowTarget } from 'app/components/molecules/Dnd/RowTarget';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import DynamicField from 'app/components/Designer/DynamicField';

const DropHereStyled = styled.div`
    height: 128px;
    border: 2px dashed white;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const RowStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

class ArrayValuesPickerDnd extends PureComponent {
    static propTypes = {
        value: PropTypes.arrayOf(PropTypes.object),
        uuid: PropTypes.string.isRequired,
    };

    static defaultProps = {
        root: true,
    };

    @bind
    onDrop(item, index) {
        this.props.onDrop(item, this.props.uuid, index);
    }

    @bind
    deleteValue(event) {
        const index = Number(event.target.dataset.index);
        this.props.deleteValue(this.props.value[index]);
    }

    @bind
    addValue() {
        this.props.addValue({ type: 'child', value: '' }, this.props.uuid, this.props.value.length);
    }

    @bind
    @memoize()
    buildDropArea(values, fieldType) {
        if (values.length === 0) {
            return (
                <RowTarget key={'empty'} index={0} onDrop={this.onDrop}>
                    <DropHereStyled>
                        <IconButton onClick={this.addValue}>
                            <MdiIcon name="plus" />
                        </IconButton>
                    </DropHereStyled>
                </RowTarget>
            );
        }
        const listItems = [
            ...values.map((val, i) => {
                const { uuid, value } = val;
                const isLastValue = values.length === i + 1;

                const target = (
                    <RowStyled>
                        <DynamicField error={!value} type={fieldType} onChange={this.props.onChange} variant="outlined" value={value} name={uuid} />
                    </RowStyled>
                );
                return (
                    <Fragment key={`${uuid}${i}`}>
                        <ListItem>
                            <ListItemText
                                primary={
                                    <Fragment>
                                        <DraggableElement key={i} index={i} element={val}>
                                            <RowTarget index={i} onDrop={this.onDrop} label={'label'} element={val}>
                                                {target}
                                            </RowTarget>
                                        </DraggableElement>
                                    </Fragment>
                                }
                            />
                            <ListItemSecondaryAction>
                                <IconButton aria-label="Delete">
                                    <MdiIcon data-index={i} name="close-circle" size={24} onClick={this.deleteValue} />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                        {isLastValue && (
                            <Grid key={`${uuid}${i}uniq`} container justify="center">
                                <IconButton onClick={this.addValue}>
                                    <MdiIcon name="plus" />
                                </IconButton>
                            </Grid>
                        )}
                    </Fragment>
                );
            }),
            <EmptyRowTarget key={'-1'} index={values.length} onDrop={this.onDrop} />,
        ];

        return (
            <List dense disablePadding>
                {listItems}
            </List>
        );
    }

    render() {
        const { fieldType, value } = this.props;
        return this.buildDropArea(value, fieldType);
    }
}

export default ArrayValuesPickerDnd;
